//=====================================================
//　G022：患者情報変更確定
//=====================================================
import { useContext, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { BtnSubmit } from "../../common/BtnSubmit";
import { ContentsBox } from "../../common/ContentsBox";
import { ContentsTitle } from "../../common/ContentsTitle";
import { CtxPatientDetailInfo, CtxClinicSystemInfo, CtxClinicInfo } from "../../utils/Contexts";
import { useAuth } from "../../utils/UseAuth";

export function G022(){

    const history = useHistory();
    const cci = useContext(CtxClinicInfo);
    const cpi = useContext(CtxPatientDetailInfo);
    const ccsi = useContext(CtxClinicSystemInfo);
    const ua = useAuth();

    // タイトル追加処理
    useEffect(function(){
        if(cci.data.name){
            document.title = cci.data.name + " | Web予約 - 患者情報変更確定";
        }else{
            document.title = process.env.REACT_APP_DEFAULT_CLININC_NAME + " | Web予約 - 患者情報変更確定";
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    // 未ログインの場合WEB予約トップへ遷移する
    if(!ua.isLoggedIn()) {
        history.push("/");
    }

    let visitNotificationMess = "" ;
    if ( cpi.data.visitNotificationMail && (cpi.data.visitNotificationSms && ccsi.data.usability.smsNotification) ){
        visitNotificationMess = "メールとSMSで通知する";
    }else if(cpi.data.visitNotificationMail ){
        visitNotificationMess = "メールで通知する";
    }else if(cpi.data.visitNotificationSms && ccsi.data.usability.smsNotification){
        visitNotificationMess = "SMSで通知する";
    }else{
        visitNotificationMess = "通知しない";
    }

    let endNotificationMess = "" ;
    if ( cpi.data.endNotificationMail && (cpi.data.endNotificationSms && ccsi.data.usability.smsNotification) ){
        endNotificationMess = "メールとSMSで通知する";
    }else if(cpi.data.endNotificationMail){
        endNotificationMess = "メールで通知する";
    }else if(cpi.data.endNotificationSms && ccsi.data.usability.smsNotification){
        endNotificationMess = "SMSで通知する";
    }else{
        endNotificationMess = "通知しない";
    }

    // 患者詳細情報の表示
    return (
        <>
            <ContentsBox>
                <ContentsTitle title="患者情報の変更が完了しました" />
                    <dl className="info_list info_list-patient">
                        <dt>お名前</dt>
                        <dd className="info_list-patient-name">{cpi.data.lastName} {cpi.data.firstName}</dd>
                        <dt>お名前（ふりがな）</dt>
                        <dd className="info_list-patient-name-kana">{cpi.data.lastNameKana} {cpi.data.firstNameKana}</dd>
                        {ccsi.data.display.birthday &&
                            <>
                                <dt>生年月日</dt>
                                <dd className="info_list-patient-birth">{cpi.data.birthday}</dd>
                            </>
                        }
                        <dt>郵便番号</dt>
                        {cpi.data.postCode1 && cpi.data.postCode2 ?  
                            <dd className="info_list-patient-post-code">{cpi.data.postCode1}-{cpi.data.postCode2}</dd>
                            :
                            <dd className="info_list-patient-post-code"></dd>
                        }
                        <dt>住所</dt>
                        <dd className="info_list-patient-address">{cpi.data.address}</dd>
                        <dt>電話番号（自宅）</dt>
                        <dd className="info_list-patient-phone-number">{cpi.data.tel}</dd>
                        <dt>電話番号（携帯）</dt>
                        <dd className="info_list-patient-cell-phone-number">{cpi.data.telPrivate}</dd>
                        <dt>パスワード</dt>
                        <dd className="info_list-patient-password">セキュリティ保護のため、パスワードは表示されません</dd>
                        <dt>E-mail</dt>
                        <dd className="info_list-patient-mail">{cpi.data.email}</dd>
                        <dt>来院通知</dt>
                        <dd className="info_list-patient-visit-notice">{visitNotificationMess}
                        </dd>
                        <dt>診療終了通知</dt>
                        <dd className="info_list-patient-finish-notice">{endNotificationMess}</dd>
                    </dl>
                <BtnSubmit title="Web予約マイページへ" onClick={function(){history.push("/mypage")}} />
            </ContentsBox>
        </>
    )
    ;

}